import React from 'react';
import NumberRangeComponent from '@intelligence/components/NumberRange';
import NumberRangePreview from '../shared/NumberRangePreview';
import { getNumberRangeValue } from '../shared/valueUtils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { INumberRangeFilterValue } from './types';

const NumberRangeRenderer: React.FC<IFilterRenderProps<INumberRangeFilterValue>> = (props) => {
  const { field, label = '', title, value, onChange, ...rest } = props;

  return (
    <NumberRangeComponent
      {...rest}
      key={field}
      title={title || label || 'dbi_number_range'}
      value={getNumberRangeValue(value)}
      onChange={(payload: any) => {
        onChange(payload);
      }}
    />
  );
};

// eslint-disable-next-line react/display-name
function renderNumberRangePreview(
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0],
  value: any,
): React.ReactNode {
  return <NumberRangePreview item={item} valueItem={value} />;
}

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  return renderNumberRangePreview;
};

export const numberRangeControl: IFilterControlModule = {
  type: FILTER_TYPE.NUMBER_RANGE,
  entry: {
    render: (props) => {
      return <NumberRangeRenderer {...props} />;
    },
  },
  getRenderPreview,
};
